import { Link } from 'react-router-dom'

export function NotFoundPage() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-ds-surface">
			<div className="text-center">
				<h1 className="text-6xl font-bold text-ds-text">404</h1>
				<p className="mt-4 text-xl text-ds-text-muted">Page not found</p>
				<Link
					to="/"
					className="mt-6 inline-block rounded-ds-md bg-ds-primary px-4 py-2 text-ds-primary-foreground hover:opacity-90"
				>
					Go Home
				</Link>
			</div>
		</div>
	)
}
